<template>
    <div class="detail-content learnProgressList_new" ref="middle_page">
        <div class="primarylists list-mobile">
            <div class="titles clear">
                <img src="../../../static/images/icon-st.jpg" alt="" />
                <div class="title l" style="text-transform: uppercase!important;">{{ $t("new.title68") }}</div>
            </div>
        </div>
        <div class="exam_begins_box">
            <div :class="[{'cts-ml': mobile, 'title-ml': !mobile}]">{{ courseName }}</div>

            <div class="exam_begins_rule">
                <el-form :model="form" class="el-row-box">
                    <el-row>
                        <!-- tên học viên -->
                        <el-col :span="12" class="row-12">
                            <el-form-item :label="$t('new.title51')">
                                <el-input :placeholder="$t('new.title69')" maxlength="100" v-model="form.name" clearable @keyup.enter.native="search_s()"></el-input>
                            </el-form-item>
                        </el-col>
                        <!-- tổ chức trực thuộc -->
                        <el-col :span="12" class="row-12">
                            <!-- <el-form-item :label="$t('new.title53_1')">
                                <div class="select-new">
                                    <select v-model="form.deptId1" class="my_select_organization" :class="{my_select_organization_disabled:form.deptId1===''}">
                                        <option value="" class="ds">{{ $t("new.title71") }}</option>
                                        <option v-for="item in deptList1" :key="item.deptId" :value="item.deptId" class="ds">
                                            {{item.name}}
                                        </option>
                                    </select>
                                </div>
                            </el-form-item> -->
                             <!-- chi nhánh -->
                            <el-form-item :label="$t('new.title54_1')" class="">
                                <div class="select-new">
                                    <select v-model="form.deptId" class="my_select_evaluate" :class="{my_select_evaluate_disabled:form.deptId===''}">
                                        <option value="" class="ds">{{ $t("new.title72") }}</option>
                                        <option v-for="item in deptList" :key="item.deptId" :value="item.deptId" class="ds">
                                            {{item.name}}
                                        </option>
                                    </select>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <!-- yêu cầu kết thúc -->
                        <el-col :span="12" class="row-12 p-inline">
                            <el-form-item :label="$t('new.title66')">
                                <p class="checkBoxlearnProgressList">
                                    <input class="ip-check" v-model="checkedValueFinished" id="checkbox_Raise1" type="checkbox" :value="cb_isFinished1.value" @change="checked_Finished(cb_isFinished1.value)" />
                                    <label for="checkbox_Raise1">{{ $t("studySituationList.notRaised") }}</label>
                                </p>
                                <p class="checkBoxlearnProgressList">
                                    <input class="ip-check" v-model="checkedValueFinished" id="checkbox_Raise2" type="checkbox" :value="cb_isFinished2.value" @change="checked_Finished(cb_isFinished1.value)" />
                                    <label for="checkbox_Raise2">{{ $t("studySituationList.raised") }}</label>
                                </p>
                            </el-form-item>
                        </el-col>
                        <!-- Đánh giá cuối kỳ -->
                        <el-col :span="12" class="row-12 p-inline">
                            <el-form-item :label="$t('scoreStatistics.judge')">
                                <p class="checkBoxlearnProgressList">
                                    <input class="ip-check" v-model="checkedValueExam" id="checkbox_Exam1" type="checkbox" :value="cb_isPass1.value" @change="checked_ValueExam(cb_isPass1.value)" />
                                    <label for="checkbox_Exam1" v-html="cb_isPass1.label"></label>
                                </p>
                                <p class="checkBoxlearnProgressList">
                                    <input class="ip-check" v-model="checkedValueExam" id="checkbox_Exam2" type="checkbox" :value="cb_isPass2.value" @change="checked_ValueExam(cb_isPass1.value)" />
                                    <label for="checkbox_Exam2" v-html="cb_isPass2.label"></label>
                                </p>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="jus-star">       
                        <!-- phạm vi tiến độ -->
                        <el-col :span="12" class="row-12">
                            <el-form-item :label="$t('new.title77')">
                                <span class="nqt-percent-pc">{{value[0]}}% - {{value[1]}}%</span>
                                <span class="nqt-percent-mobile">{{value[0]}}%</span>
                                <el-slider v-model="value" range></el-slider>
                                <span class="nqt-percent-mobile">{{value[1]}}%</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" class="row-12">
                           <div class="nqt-pc">
                              <input class="ip-check" id="check_box_pc" type="checkbox" v-model="form.vp" size="medium" style="vertical-align: middle; margin-top: 0;" />
                              <label for="check_box_pc" style="vertical-align: middle; margin-top: 0; margin-left: 5px; font-size: 14px;">{{ $t("new.title67") }}</label>
                           </div>
                        </el-col>
                    </el-row>
                    <el-row class="nqt-mobile">
                        <el-col :span="12" class="row-12">
                            <el-form-item label label-width="150px" class="mg-l">
                                <p>
                                    <input class="ip-check" id="check_box" type="checkbox" v-model="form.vp" size="medium" style="vertical-align: middle; margin-top: 0;" />
                                    <label for="check_box" style="vertical-align: middle; margin-top: 0; margin-left: 5px; font-size: 14px;">{{ $t("new.title67") }}</label>
                                </p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12"></el-col>
                    </el-row>
                    <el-form-item label class="font_col">
                        <el-button class="btn-login" style="border-radius: 20px;" @click="search_s">{{ $t("scoreStatistics.search") }}</el-button>

                        <el-button v-if="!isCheckedStatus" class="btn-login btn-exel" style="border-radius: 20px; margin-right: 5px;" @click="exportExcel" :title="$t('new.title70')">{{ $t("new.title79") }}</el-button>

                        <el-button class="btn-login" style="border-radius: 20px;" @click="reset()">{{ $t("new.title85") }}</el-button>

                        <el-button class="btn-login btn-back" style="border-radius: 20px;" @click="goto_Aicourse"><span>{{ $t("common.returnButton") }}</span></el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div class="course_box" v-if="!mobile">
                <div class="exam_begins_rule_content" v-if="!loading && tableInfo.length">
                    <el-table :data="pagedTableInfo" @header-click="sortTable" :header-cell-style="tableHeaderStyle">
                        <el-table-column fixed type="index" :label="$t('courseList.no')" header-align="center" align="center" width="50">
                            <template slot-scope="scope">{{ (page - 1) * limit + scope.$index + 1 }}</template>
                        </el-table-column>
                        <!-- tên học viên -->
                        <el-table-column prop="name" :label="$t('new.title51')" fixed header-align="center" align="left" show-overflow-tooltip width="220" :render-header="icons"></el-table-column>
                        <!-- chi nhánh 2 -->
                        <el-table-column prop="deptName" :label="$t('new.title54_1')" header-align="center" min-width="220px" :render-header="icons">
                            <template slot-scope="scope">
                                <span v-if="scope.row.deptName != undefined && scope.row.deptName != null && scope.row.deptName != ''">{{ scope.row.deptName }}</span>
                                <span v-if="scope.row.deptName == undefined || scope.row.deptName == null || scope.row.deptName == ''">-</span>
                            </template>
                        </el-table-column>
                        <!-- tiến độ học tập -->
                        <el-table-column prop="schedule" :label="$t('new.title57')" header-align="center" align="center" min-width="120px" width="160" :render-header="icons">
                            <template slot-scope="scope" align="right">
                                <el-progress :percentage="Number(Math.abs(scope.row.schedule)) > 100 ? 100 : Number(Math.abs(scope.row.schedule))"
                                    :stroke-width="20"
                                    :text-inside="true"
                                    :color="setColor(Number(Math.abs(scope.row.schedule)))"
                                    :format="formats(scope.$index, Number(Math.abs(scope.row.schedule)))"
                                ></el-progress>
                            </template>
                        </el-table-column>
                        <!-- tên kỳ thi -->
                        <el-table-column prop="userScore" :label="$t('scoreStatistics.testName')" header-align="center" align="center" width="220" :render-header="icons">
                            <template slot-scope="scope">
                                <span v-if="scope.row.examName == null && scope.row.userScore != null">{{ $t("scoreStatistics.finalExam") }}</span>
                                <span v-else-if="scope.row.examName != null && scope.row.userScore != null">{{ scope.row.examName }}</span>
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                        <!-- điểm thi cuối kỳ -->
                        <el-table-column prop="userScore" :label="$t('new.title58')" header-align="center" align="center" width="160" :render-header="icons">
                            <template slot-scope="scope">
                                <span v-if="scope.row.userScore == undefined || scope.row.userScore == null || scope.row.userScore == '' && scope.row.userScore != 0">-</span>
                                <span v-else>{{ scope.row.userScore }}</span>
                            </template>
                        </el-table-column>
                        <!-- đánh giá cuối kỳ-->
                        <el-table-column prop="isPassFlag" :label="$t('scoreStatistics.judge')" header-align="center" align="center" width="160" :render-header="icons">
                            <template slot-scope="scope">
                                <span v-if="scope.row.userScore == null">-</span>
                                <span v-else>{{scope.row.isPassFlag}}</span>
                            </template>
                        </el-table-column>
                        <!-- Ngày dự thi-->
                        <!-- <el-table-column prop="examDate" :label="$t('examResume.time')" header-align="center" align="center" width="160" :render-header="icons">
                            <template slot-scope="scope">
                                <span v-if="scope.row.examDate == null">-</span>
                                <span v-else>{{scope.row.examDate}}</span>
                            </template>
                        </el-table-column> -->
                        <!-- Thời gian bắt đầu thi-->
                        <el-table-column prop="timeExamStart" :label="$t('scoreStaticNew.timeExamStart')" header-align="center" align="center" width="180" :render-header="icons">
                            <template slot-scope="scope">
                                <span v-if="scope.row.timeExamStart == null">-</span>
                                <span v-else>{{scope.row.timeExamStart}}</span>
                            </template>
                        </el-table-column>
                        <!-- Thời gian kết thúc thi-->
                        <el-table-column prop="timeExamEnd" :label="$t('scoreStaticNew.timeExamEnd')" header-align="center" align="center" width="180" :render-header="icons">
                            <template slot-scope="scope">
                                <span v-if="scope.row.timeExamEnd == null">-</span>
                                <span v-else>{{scope.row.timeExamEnd}}</span>
                            </template>
                        </el-table-column>
                        <!-- Thời làm bài-->
                        <el-table-column prop="timeExamConduct" :label="$t('scoreStaticNew.timeExamConductedNew')" header-align="center" align="center" width="180" :render-header="icons">
                            <template slot-scope="scope">
                                <span v-if="scope.row.timeExamConduct == null">-</span>
                                <span v-else>{{parseInt(scope.row.timeExamConduct)}} {{$t('manage_student.minute')}}</span>
                            </template>
                        </el-table-column>
                        <!-- ngày bắt đầu học -->
                        <el-table-column prop="dateStart" :label="$t('new.title60')" header-align="center" align="center" min-width="110px" width="180" :render-header="icons">
                            <template slot-scope="scope">
                                <span v-if="scope.row.dateStart != undefined && scope.row.dateStart != null && scope.row.dateStart != ''">{{ scope.row.dateStart }}</span>
                                <span v-if="scope.row.dateStart == undefined || scope.row.dateStart == null || scope.row.dateStart == ''">-</span>
                            </template>
                        </el-table-column>
                        <!-- ngày kết thúc học tập -->
                        <el-table-column prop="dateEnd" :label="$t('new.title61')" header-align="center" align="center" min-width="110px" width="160" :render-header="icons">
                            <template slot-scope="scope">
                                <span v-if=" scope.row.dateEnd != undefined && scope.row.dateEnd != null && scope.row.dateEnd != ''">
                                    {{ scope.row.dateEnd }}
                                </span>
                                <span v-if="scope.row.dateEnd == undefined || scope.row.dateEnd == null || scope.row.dateEnd == ''">-</span>
                            </template>
                        </el-table-column>
                        <!-- số chương đã học -->
                        <el-table-column prop="sum" :label="$t('new.title62')" header-align="center" align="center" min-width="110px" width="160" :render-header="icons">
                            <template slot-scope="scope">
                                <span>{{ Number(Math.abs(scope.row.sum)) }}</span>
                            </template>
                        </el-table-column>
                        <!-- số chương chưa học -->
                        <el-table-column prop="total" :label="$t('new.title63')" header-align="center" align="center" min-width="90px" width="180" :render-header="icons"></el-table-column>
                        <!-- bản cam kết -->
                        <template v-if="checkBangCamKet">
                            <el-table-column prop="isGuarantee" :label="$t('new.title64')" header-align="center" align="center" min-width="90px" width="160" :render-header="icons">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.isGuarantee == 1">{{ $t("studySituationList.raised") }}</span>
                                    <span v-if="scope.row.isGuarantee == 0">{{ $t("studySituationList.notRaised") }}</span>
                                    <span v-if="scope.row.isGuarantee == 2">-</span>
                                </template>
                            </el-table-column>
                        </template>
                        <!-- bảng câu hỏi -->
                        <template v-if="checkBangKhaoSat">
                            <el-table-column prop="isQuestionnaire" :label="$t('new.title65')" header-align="center" align="center" min-width="90px" width="160" :render-header="icons">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.isQuestionnaire == 1">{{ $t("studySituationList.raised") }}</span>
                                    <span v-if="scope.row.isQuestionnaire == 0">{{ $t("studySituationList.notRaised") }}</span>
                                    <span v-if="scope.row.isQuestionnaire == 2">-</span>
                                </template>
                            </el-table-column>
                        </template>
                        <!-- tổ chức trực thuộc -->
                        <el-table-column prop="deptName1" :label="$t('new.title53_1')" header-align="center" min-width="220px" :render-header="icons">
                            <template slot-scope="scope">
                                <span v-if="scope.row.deptName1 != undefined && scope.row.deptName1 != null && scope.row.deptName1 != ''">{{ scope.row.deptName1 }}</span>
                                <span v-if="scope.row.deptName1 == undefined || scope.row.deptName1 == null || scope.row.deptName1 == ''">-</span>
                            </template>
                        </el-table-column>
                        <!-- nqt:add -->
                        <el-table-column prop="exitDate" :render-header="icons" :label="$t('new.title55')" header-align="center" align="center" min-width="110px" width="160">
                            <template slot-scope="scope">
                                <span v-if="scope.row.exitDate != undefined && scope.row.exitDate != null && scope.row.exitDate != ''">{{scope.row.exitDate}}</span>
                                <span v-if="scope.row.exitDate == undefined || scope.row.exitDate == null || scope.row.exitDate == ''">-</span>
                            </template>
                        </el-table-column>
                        <!-- đơn đăng ký kết thúc -->
                        <el-table-column prop="isFinished" :label="$t('new.title66')" header-align="center" align="center" min-width="90px" width="160" :render-header="icons">
                            <template slot-scope="scope">
                                <span v-if="scope.row.isFinished == 1">{{ $t("studySituationList.raised") }}</span>
                                <span v-if="scope.row.isFinished == 0">{{ $t("studySituationList.notRaised") }}</span>
                                <span v-if="scope.row.isFinished == 2">-</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-col :span="24" class="toolbar" style="text-align: center;" v-if="tableInfo.length > 0">
                        <el-pagination @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize" layout="pager" :total="this.tableInfo.length" background></el-pagination>
                    </el-col>
                </div>
            </div>
            <!-- mobile course_box -->
            <div class="course_box_mobile" v-if="mobile">
                <template v-if="!loading && tableInfo.length">
                    <div class="box-1" @click="activeRow(index)" v-for="(item, index) in pagedTableInfo" :key="item.value">
                        <div class="title_course_box" :class="{'turn-arrow': activeID == index}">
                            <div class="num_order">
                                {{ (page - 1) * limit + index + 1 }}
                            </div>
                            <div class="title_course">
                                {{ item.name }}
                            </div>
                        </div>
                        <div class="content_box" :class="{'active-content': activeID == index}">
                            <div class="content_new">
                                <h1>{{ $t("new.title53_1") }}:</h1>
                                <span v-if="item.deptName1 != undefined && item.deptName1 != null &&  item.deptName1 != ''">{{ item.deptName1 }}</span>
                                <span v-if="item.deptName1 == undefined || item.deptName1 == null || item.deptName1 == ''">-
                                </span>
                            </div>
                            <div class="content_new">
                                <h1>{{ $t("new.title54_1") }}:</h1>
                                <span
                                    v-if="item.deptName != undefined && item.deptName != null && item.deptName != ''">{{ item.deptName }}</span>
                                <span v-if="item.deptName == undefined || item.deptName == null || item.deptName == ''">-</span>
                            </div>
                            <!-- nqt:add -->
                            <div class="content_new">
                                <h1>{{ $t("new.title55") }}:</h1>
                                <span v-if="item.exitDate != undefined && item.exitDate != null && item.exitDate != ''">
                                    {{ item.exitDate }}
                                </span>
                                <span v-if="item.exitDate == undefined || item.exitDate == null || item.exitDate == ''">-</span>
                            </div>
                            <!--  -->
                            <div class="content_new">
                                <h1>{{ $t("new.title57") }}:</h1>
                                <span>{{ Number(Math.abs(item.schedule)) }}%</span>
                            </div>
                            <div class="content_new">
                                <h1>{{ $t("scoreStatistics.testName") }}:</h1>
                                <span v-if="item.examName == null && item.userScore != null">{{ $t("scoreStatistics.finalExam") }}</span>
                                <span v-else-if="item.examName != null && item.userScore != null">{{ item.examName }}</span>
                                <span v-else>-</span>
                            </div>
                            <div class="content_new">
                                <h1>{{ $t("new.title58") }}:</h1>
                                <span v-if="item.userScore == undefined || item.userScore == null || item.userScore == '' && item.userScore != 0">-</span>
                                <span v-else>{{ item.userScore }}</span>
                            </div>
                            <div class="content_new">
                                <h1>{{ $t("scoreStatistics.judge") }}:</h1>
                                <span v-if="item.userScore == null">-</span>
                                <span v-else>{{item.isPassFlag}}</span>
                            </div>
                            <!-- <div class="content_new">
                                <h1>{{ $t("examResume.time") }}:</h1>
                                <span>{{ item.examDate }}</span>
                            </div> -->
                            <div class="content_new">
                                <h1>{{ $t("scoreStaticNew.timeExamConductedNew") }}:</h1>
                                <span>{{ item.timeExamConduct }} {{$t('manage_student.minute')}}</span>
                            </div>
                            <div class="content_new">
                                <h1>{{ $t("scoreStaticNew.timeExamStart") }}:</h1>
                                <span>{{ item.timeExamStart }}</span>
                            </div>
                            <div class="content_new">
                                <h1>{{ $t("scoreStaticNew.timeExamEnd") }}:</h1>
                                <span>{{ item.timeExamEnd }}</span>
                            </div>
                            <div class="content_new">
                                <h1>{{ $t("new.title60") }}:</h1>
                                <span v-if="item.dateStart != undefined && item.dateStart != null && item.dateStart != ''">{{ item.dateStart }}</span>
                                <span v-if="item.dateStart == undefined || item.dateStart == null || item.dateStart == ''">-</span>
                            </div>
                            <div class="content_new">
                                <h1>{{ $t("new.title61") }}:</h1>
                                <span v-if="item.dateEnd != undefined && item.dateEnd != null && item.dateEnd != ''">{{ item.dateEnd }}</span>
                                <span v-if="item.dateEnd == undefined || item.dateEnd == null || item.dateEnd == ''">-</span>
                            </div>
                            <div class="content_new">
                                <h1>{{ $t("new.title62") }}:</h1>
                                <span>{{ Number(Math.abs(item.sum)) }}</span>
                            </div>
                            <div class="content_new">
                                <h1>{{ $t("new.title63") }}:</h1>
                                <span>{{ item.total }}</span>
                            </div>
                            <div v-if="item.isGuarantee == 1 || item.isGuarantee == 0" class="content_new">
                                <h1>{{ $t("new.title64") }}:</h1>
                                <span v-if="item.isGuarantee == 1">{{ $t("studySituationList.raised") }}</span>
                                <span v-if="item.isGuarantee == 0">{{ $t("studySituationList.notRaised") }}</span>
                                <span v-if="item.isGuarantee == 2">-</span>
                            </div>
                            <div v-if="item.isQuestionnaire == 1 || item.isQuestionnaire == 0" class="content_new">
                                <h1>{{ $t("new.title65") }}:</h1>
                                <span v-if="item.isQuestionnaire == 1">{{ $t("studySituationList.raised") }}</span>
                                <span v-if="item.isQuestionnaire == 0">{{ $t("studySituationList.notRaised") }}</span>
                                <span v-if="item.isQuestionnaire == 2">-</span>
                            </div>
                            <div class="content_new">
                                <h1>{{ $t("new.title66") }}:</h1>
                                <span v-if="item.isFinished == 1">{{ $t("studySituationList.raised") }}</span>
                                <span v-if="item.isFinished == 0">{{ $t("studySituationList.notRaised") }}</span>
                                <span v-if="item.isFinished == 2">-</span>
                            </div>
                        </div>
                    </div>
                    <el-col :span="24" class="toolbar" style="text-align: center;">
                        <el-pagination @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize" layout="pager" :total="tableInfo.length" background></el-pagination>
                    </el-col>
                </template>
            </div>
            <!-- end mobile course_box-->

            <div v-show="tableInfo.length == 0 && checkSearch == true && !loading" class="no-content">
                <img src="../../../static/images/noresult.jpg" alt />
                <p>{{ $t("search.result") }}</p>
            </div>

            <!-- Loading -->
            <loading class="loading--lesson" :showLoading="loading"/>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import { mapState, mapMutations } from "vuex";
    import { lang } from "../../assets/languages/getLanguageType.js";
    Vue.prototype.$lang = lang;
    import loading from "@/components/loading/loading";
    import en from "element-ui/lib/locale/lang/en";
    import ja from "element-ui/lib/locale/lang/ja";
    import vi from "element-ui/lib/locale/lang/vi";
    import zh from "element-ui/lib/locale/lang/zh-CN";
    import picker from "../../../node_modules/element-ui/lib/locale/index";

    export default {
        name: "progessLesson",
        data() {
            return {
                checkedValueExam: [],
                cb_isPass1: {},
                cb_isPass2: {},
                checkedValueFinished: [],
                cb_isFinished1: {},
                cb_isFinished2: {},
                min: 0,
                max: 0,
                value: [0, 100],
                minA: 0,
                maxA: 100,
                minB: 0,
                maxB: 100,
                form: {
                    deptId1: "",
                    deptId: "",
                },
                formOld: {
                    courseId: null,
                    userId: null,
                    language: null,
                    companyId: null,
                    name: null,
                    deptId1: null,
                    deptId: null,
                    isRequire: null,
                    beginSchedule: null,
                    endSchedule: null,
                    isPass: null,
                    isFinished: null,
                    region: null,
                    vp: false,
                },
                resultFlag: false,
                pageNum: 1,
                pageSize: 10,
                totalPage: 0,
                total: 14,
                page: 1,
                limit: 10,
                item: null,
                userId: null,
                courseId: null,
                courseName: null,
                deptList: [],
                deptList1: [],
                courseTypeList: [],
                regionList: [],
                passList: [],
                tableInfo: [],
                checkSearch: false,
                isCheckedStatus: false,
                activeID: null,
                asc: false,
                checkBangCamKet: false,
                checkBangKhaoSat: false,
                listSort: [
                    {
                        colName: "name",
                        asc: true,
                    },
                    {
                        colName: "deptName",
                        asc: true,
                    },
                    {
                        colName: "schedule",
                        asc: false,
                    },
                    {
                        colName: "userScore",
                        asc: true,
                    },
                    {
                        colName: "isPassFlag",
                        asc: true,
                    },
                    // {
                    //     colName: "examDate",
                    //     asc: true,
                    // },
                    {
                        colName: "timeExamStart",
                        asc: true,
                    },
                    {
                        colName: "timeExamEnd",
                        asc: true,
                    },
                    {
                        colName: "timeExamConduct",
                        asc: true,
                    },
                    {
                        colName: "dateStart",
                        asc: true,
                    },
                    {
                        colName: "dateEnd",
                        asc: true,
                    },
                    {
                        colName: "sum",
                        asc: true,
                    },
                    {
                        colName: "total",
                        asc: true,
                    },
                    {
                        colName: "isGuarantee",
                        asc: true,
                    },
                    {
                        colName: "isQuestionnaire",
                        asc: true,
                    },
                    {
                        colName: "deptName1",
                        asc: true,
                    },
                    {
                        colName: "exitDate",
                        asc: true,
                    },
                    {
                        colName: "isFinished",
                        asc: true,
                    },
                ],
            };
        },
        components: {
            loading
        },
        computed: {
            pagedTableInfo() {
                // console.log(this.tableInfo);
                this.tableInfo.forEach(val => {
                    if (val['userScore'] != null && val['isPassFlag'] == "1") val['isPassFlag'] = this.$t("scoreStatistics.point90");
                    if (val['userScore'] != null && val['isPassFlag'] == "0") val['isPassFlag'] = this.$t("scoreStatistics.point80");
                    if (val['userScore'] == null && val['isPassFlag'] == "0") val['isPassFlag'] = '-';
                })
                return this.tableInfo.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
            },
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile,
                loading: (state) => state.progessLesson.loading,
            }),
        },
        mounted() {
            if (this._isMobile()) {
                this.isCheckedStatus = true;
            } else {
                this.isCheckedStatus = false;
            }
            $(".my_select_organization").change(function () {
                $(".my_select_organization").removeClass("my_select_organization_disabled");
            });
            $(".my_select_evaluate").change(function () {
                $(".my_select_evaluate").removeClass("my_select_evaluate_disabled");
            });
            //获取设备屏幕的高度
            const h = document.body.clientHeight - 50;
            // this.$refs.middle_page.style.minHeight = h + "px";

            this.$autoLogin().then(
                () => {
                    const that = this;
                    //接收参数
                    that.courseId = that.$route.query.courseId;
                    that.courseName = that.$route.query.courseName;
                    //登录成功
                    that.userId = window.sessionStorage.getItem("id");
                    that.role = window.sessionStorage.getItem("role");
                    //获取课程总况信息
                    that.setLoading(true);
                    that.$api
                        .post("/courseTrainee/getData", {
                            courseId: that.courseId,
                            language: that.$lang(),
                            // pageQuery: {
                            //   pageNum: that.pageNum,
                            //   pageSize: that.pageSize,
                            // },
                        })
                        .then((response) => {
                            that.formOld.courseId = that.courseId;
                            that.formOld.userId = that.userId;
                            that.formOld.language = that.language;
                            that.formOld.companyId = that.companyId;

                            that.deptList = response.data.deptList;
                            that.deptList1 = response.data.deptList1;
                            that.courseTypeList = response.data.courseTypeList;
                            that.regionList = response.data.regionList;
                            that.passList = response.data.passList;
                            that.total = response.data.courseTraineeList.total;
                            if (response.data.courseTraineeList.list.length > 0) {
                                response.data.courseTraineeList.list.forEach(value => {
                                    if(value.isGuarantee=="0"||value.isGuarantee=="1"){
                                        that.checkBangCamKet = true;
                                    }
                                    if(value.isQuestionnaire=="0"||value.isQuestionnaire=="1"){
                                        that.checkBangKhaoSat = true;
                                    }
                                });
                                that.resultFlag = true;
                                that.totalPage = response.data.courseTraineeList.pages;
                                that.tableInfo = response.data.courseTraineeList.list;
                            } else {
                                that.totalPage = 0;
                                that.tableInfo = [];
                                that.resultFlag = false;
                            }
                            if (response.data.passList != null) {
                                for (var k = 0; k < response.data.passList.length; k++) {
                                    if (k === 0) {
                                        that.cb_isPass1 = response.data.passList[k];
                                    }
                                    if (k === 1) {
                                        that.cb_isPass2 = response.data.passList[k];
                                    }
                                }
                            }
                            if (response.data.raisedList != null) {
                                for (var k = 0; k < response.data.raisedList.length; k++) {
                                    if (k === 0) {
                                        that.cb_isFinished1 = response.data.raisedList[k];
                                    }
                                    if (k === 1) {
                                        that.cb_isFinished2 = response.data.raisedList[k];
                                    }
                                }
                            }
                            this.setLoading(false);
                            document.getElementById("app").scrollTo(0, 0);
                        });
                },
                () => {
                    //未登录跳回首页
                    this.$router.push({
                        path: "/home",
                    });
                    this.$message.warning(window.vm.$i18n.t("read.login"));
                }
            );
        },
        methods: {
            ...mapMutations("progessLesson", ["setLoading"]),
            tableHeaderStyle({ columnIndex }) {
                if (columnIndex != 0) return "cursor: pointer";
            },
            sortTable(column) {
                if (column.property != undefined) {
                    let key = this.listSort.findIndex((item) => item.colName == column.property);
                    this.listSort[key].asc = !this.listSort[key].asc;
                    this.tableInfo = this.sortedTables(this.tableInfo, column.property, this.listSort[key].asc);
                }
            },
            sortedTables(data, element, type) {
                if (element == "name" || element == "deptName1" || element == "deptName" || element == "exitDate" || element == "dateEnd" || element == "dateStart" || element == "isPassFlag") {
                    data.forEach((val) => {
                        if (val[element] == null) val[element] = "";
                    });
                    return type ? data.sort((a, b) => a[element].localeCompare(b[element])) : data.sort((a, b) => b[element].localeCompare(a[element]));
                } else {
                    if (type) {
                        return data.sort((a, b) => {
                            if (a[element] === null) {
                                return parseInt("-1") - parseInt(b[element]);
                            } else if (b[element] === null) {
                                return parseInt(a[element]) - parseInt("-1");
                            } else {
                                return parseInt(a[element]) - parseInt(b[element]);
                            }
                        });
                    } else {
                        return data.sort((a, b) => {
                            if (a[element] == null) {
                                return parseInt(b[element]) - parseInt("-1");
                            } else if (b[element] == null) {
                                return parseInt("-1") - parseInt(a[element]);
                            } else {
                                return parseInt(b[element]) - parseInt(a[element]);
                            }
                        });
                    }
                }
            },
            icons(h, { column }) {
                return [
                    h("span", column.label),
                    h("i", {
                        class: "el-icon-d-caret",
                        style: "color:#ffffff;margin-left:3px;",
                    }),
                ];
            },
            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
                return flag;
            },
            checked_Finished(value) {
                if (this.checkedValueFinished.length === 2) {
                    this.checkedValueFinished.splice(0, 1);
                }
            },
            checked_ValueExam(value) {
                if (this.checkedValueExam.length === 2) {
                    this.checkedValueExam.splice(0, 1);
                }
            },
            setColor(learningProcess) {
                if (Number(learningProcess) >= 80) {
                    return "#67C23A";
                } else if (Number(learningProcess) < 80 && Number(learningProcess) >= 60) {
                    return "#409EFF";
                } else if (Number(learningProcess) < 60 && Number(learningProcess) >= 40) {
                    return "#FFCC00";
                } else if (Number(learningProcess) < 40 && Number(learningProcess) >= 20) {
                    return "#FF6600";
                } else if (Number(learningProcess) < 20) {
                    return "#FF3300";
                }
            },
            formats(index, learnPercent) {
                if (document.getElementsByClassName("el-progress-bar__innerText")[index] != null) {
                    document.getElementsByClassName("el-progress-bar__innerText")[index].innerText = learnPercent + "%";
                }
            },
            checkSt: function (sts) {
                if (sts == 1) {
                    return this.$t("studySituationList.raised")
                }

                if (sts == 0) {
                    return this.$t("studySituationList.notRaised")
                }

                return "ー";
            },
            exportExcel: function () {
                const self = this;
                let dt = this.tableInfo;
                var csv = [];
                dt.forEach((item) => {
                    let examName = '--';

                    if (item.examName == null && item.userScore != null) {
                        examName = self.$t("scoreStatistics.finalExam");
                    } else if (item.examName != null && item.userScore != null) {
                        examName = item.examName;
                    } else {
                        examName = "―";
                    }
                    if (item.deptName==null) {
                        item.deptName = "_";
                    } else {
                        item.deptName = item.deptName.replace(/,/g, " |");
                    }
                    let obj = {
                        name: item.name,
                        deptName: item.deptName,
                        schedule: item.schedule,
                        testName: examName,
                        isPassFlag: item.isPassFlag != null && item.isPassFlag != "-" && item.isPassFlag != "―" ? item.isPassFlag : "―",
                        timeExamStart: item.timeExamStart != null ? item.timeExamStart : "―",
                        timeExamEnd: item.timeExamEnd != null ? item.timeExamEnd : "―",
                        timeExamConduct: item.timeExamConduct != null ? item.timeExamConduct : "―",
                        dateStart : item.dateStart != null && item.dateStart != "" ? item.dateStart : "―",
                        dateEnd : item.dateEnd != null && item.dateEnd != "" ? item.dateEnd : "―",
                        sum : item.sum != null ? item.sum : "―",
                        exitDate : item.exitDate != null ? item.exitDate : "―",
                        userScore : item.userScore != null ? item.userScore : "―",
                        total : item.total != null ? item.total : "―",
                        isGuarantee : self.checkSt(item.isGuarantee),
                        isQuestionnaire : self.checkSt(item.isQuestionnaire),
                        isFinished : self.checkSt(item.isFinished)
                    }
                    csv.push(obj);
                });
                if (csv.length==0) {
                    this.$confirm(window.vm.$i18n.t("new.title185"), window.vm.$i18n.t("new.title86"), { cancelButtonClass: "btn-nqt---show" })
                    .then(() => {})
                    return;
                }
                // Khai báo header CSV
                var headerName = [
                    {
                        key: "name",
                        value: "new.title51",
                    },
                    {
                        key: "deptName",
                        value: "new.title54_1",
                    },
                    {
                        key: "schedule",
                        value: "new.title57",
                    },
                    {
                        key: "testName",
                        value: "scoreStatistics.testName",
                    },
                    {
                        key: "userScore",
                        value: "new.title58",
                    },
                    {
                        key: "isPassFlag",
                        value: "scoreStatistics.judge",
                    },
                    {
                        key: "timeExamStart",
                        value: "scoreStaticNew.timeExamStart",
                    },
                    {
                        key: "timeExamEnd",
                        value: "scoreStaticNew.timeExamEnd",
                    },
                    {
                        key: "timeExamConduct",
                        value: "scoreStaticNew.timeExamConducted",
                    },
                    {
                        key: "dateStart",
                        value: "new.title60",
                    },
                    {
                        key: "dateEnd",
                        value: "new.title61",
                    },
                    {
                        key: "sum",
                        value: "new.title62",
                    },
                    {
                        key: "total",
                        value: "new.title63",
                    },
                    {
                        key: "isGuarantee",
                        value: "new.title64",
                    },
                    {
                        key: "isQuestionnaire",
                        value: "new.title65",
                    },
                    {
                        key: "exitDate",
                        value: "new.title55",
                    },
                    {
                        key: "isFinished",
                        value: "new.title66",
                    }
                ];
                var params = {
                    header: true,
                    titles: ['name', 'deptName', 'schedule', 'testName', 'userScore', 'isPassFlag', 'timeExamStart', 'timeExamEnd', 'timeExamConduct', 'dateStart', 'dateEnd', 'sum', 'total', 'isGuarantee', 'isQuestionnaire', 'exitDate', 'isFinished'],
                    data: csv,
                    headerName: headerName,
                };

                // Download
                this.exportCsv(params);
            },
            //点击搜索按钮
            search() {
                const that = this;
                let isPassResult = null;
                let isFinishedResult = null;
                if (this.checkedValueExam.length === 1) {
                    isPassResult = this.checkedValueExam[0];
                }
                if (this.checkedValueFinished.length === 1) {
                    isFinishedResult = this.checkedValueFinished[0];
                }
                this.min = this.value[0];
                this.max = this.value[1];
                this.setLoading(true);
                that.$api
                    .post("/courseTrainee/getData", {
                        courseId: that.courseId,
                        language: that.$lang(),
                        // pageQuery: {
                        //   pageNum: that.pageNum,
                        //   pageSize: that.pageSize,
                        // },
                        name: that.form.name,
                        deptId1: that.form.deptId1,
                        deptId: that.form.deptId,
                        isRequire: that.form.isRequire,
                        beginSchedule: this.min,
                        endSchedule: this.max,
                        isPass: isPassResult,
                        isFinished: isFinishedResult,
                        region: that.form.region,
                        vp: that.form.vp ? 1 : 0,
                    })
                    .then((response) => {
                        if (this.checkedValueExam.length === 1) {
                            that.formOld.isPass = this.checkedValueExam[0];
                        }
                        if (this.checkedValueFinished.length === 1) {
                            that.formOld.isFinished = this.checkedValueFinished[0];
                        }
                        //that.formOld = that.form;
                        that.formOld.name = that.form.name;
                        that.formOld.deptId1 = that.form.deptId1;
                        that.formOld.deptId = that.form.deptId;
                        that.formOld.isRequire = that.form.isRequire;
                        that.formOld.beginSchedule = that.form.beginSchedule;
                        that.formOld.endSchedule = that.form.endSchedule;
                        that.formOld.isFinished = that.form.isFinished;
                        (that.formOld.region = that.form.region), (that.formOld.vp = that.form.vp);
                        that.deptList = response.data.deptList;
                        that.deptList1 = response.data.deptList1;
                        that.courseTypeList = response.data.courseTypeList;
                        that.passList = response.data.passList;
                        if (response.data.courseTraineeList.list.length > 0) {
                            if (isPassResult==0) {
                                that.resultFlag = true;
                                /// check lại page với 10 record 1 page
                                that.totalPage = response.data.courseTraineeList.pages;
                                /// check lại page với 10 record
                                that.total = response.data.courseTraineeList.total;
                                let listNoPass = [];
                                response.data.courseTraineeList.list.forEach(value => {
                                    if (value.userScore!=null&&value.isPassFlag=="0"){
                                        listNoPass.push(value);
                                    }
                                });
                                that.tableInfo = this.sortedTables(listNoPass, "schedule", this.asc);
                            } else {
                                that.resultFlag = true;
                                that.totalPage = response.data.courseTraineeList.pages;
                                that.total = response.data.courseTraineeList.total;
                                that.tableInfo = this.sortedTables(response.data.courseTraineeList.list, "schedule", this.asc);
                            }
                        } else {
                            that.totalPage = 0;
                            that.tableInfo = [];
                            that.resultFlag = false;
                            this.checkSearch = true;
                        }
                        this.setLoading(false);
                        document.getElementById("app").scrollTo(0, 0);
                    });
                $("html, body").animate(
                    {
                        scrollTop: $("html, body").get(0).scrollHeight,
                    },
                    2000
                );
            },
            search_s() {
                this.pageNum = 1;
                this.page = 1;
                this.search();
                this.handleCurrentChange(1);
            },
            handleCurrentChange(val) {
                // 改变默认的页数
                //this.currentPage=val
                this.page = val;
                this.activeID = null;
                this.pageNum = val;
                // this.search();
            },
            goto_Aicourse: function () {
                this.$router.push({
                    name: "Aicourse",
                    query: {
                        buyCourseId: this.courseId,
                        buyCollegeId: JSON.stringify(1),
                    },
                });
            },
            activeRow: function (activeID) {
                if (this.activeID == activeID && this.activeID != null) {
                    this.activeID = null;
                } else {
                    this.activeID = activeID;
                }
            },
            reset: function () {
                this.form = {};
                this.form.deptId1 = "";
                this.form.deptId = "";
                this.checkedValueFinished = [];
                this.checkedValueExam = [];
                this.value = [0, 100];
                $(".my_select_organization").addClass("my_select_organization_disabled");
                $(".my_select_evaluate").addClass("my_select_evaluate_disabled");
                this.checkSearch = false;
            },
        },
    };
</script>

<style scoped="scoped">
    .cts-ml {
        min-height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        white-space: normal;
        font-size: 22px;
        padding: 10px 20px;
    }
    .loading {
        position: absolute;
    }
    @media (max-width: 834px) {
        .checkBoxlearnProgressList {
            padding-top: 0px!important;
        }
        .nqt-mobile {
            display: block !important;
        }
        .nqt-pc {
            display: none !important;
        }
    }
    .nqt-mobile {
        display: none;
    }
    .nqt-pc {
        margin-left: 200px;
        display: block;
    }
    .page-bk-col {
        background-color: #ffffff;
    }
    .font_col {
        text-align: center;
        color: #fff;
    }
    .exam_page {
        width: 100%;
        background: url(/static/images/bg/personset_bg.jpg);
        background-size: cover;
        background-repeat: no-repeat;
        display: flex;
        position: relative;
        min-height: 100vh;
    }

    .exam_main {
        background-color: rgb(65, 65, 65, 0.5);
        width: 100%;
        height: 100%;
        padding-bottom: 50px;
        min-height: calc(100vh - 50px);
    }

    .examPage {
        width: 100%;
        margin: 0 auto;
        padding-top: 20px;
    }

    .examCenter_img {
        margin-top: 40px;
        width: 40%;
        margin-left: calc(20% - 30px);
        position: relative;
    }

    .examCenter_img img {
        height: 120px;
    }

    .examCenter_img p:first-child {
        font-size: 40px;
        color: #fafafa;
        font-family: marzo-w00-regular, fantasy;
        font-weight: 400;
    }

    .examCenter_img p:first-child span {
        font-size: 40px;
        color: #ff5252;
        font-family: braggadocio-w01, fantasy;
        font-weight: 400;
    }

    .examCenter_img p:nth-child(2) {
        font-size: 45px;
        color: #e8e6e6;
        font-family: roboto-thin, roboto, sans-serif;
        font-weight: 400;
    }

    .exam_begins_box {
        width: 95%;
        padding: 30px;
        border-radius: 15px;
        margin: 0 auto;
        margin-top: 80px;
        background-color: rgba(0, 0, 0, 0.3);
        box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
        position: relative;
    }

    .course_box {
        width: 100%;
        border-radius: 15px;
        /* background-color: rgba(0, 0, 0, 0.3); */
        /* box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3); */
        position: relative;
        margin-bottom: 20px;
    }

    .exam_page_span {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.3);
    }

    .examination_notes {
        height: 20px;
        font-size: 20px;
        color: #e8e6e6;
        text-align: center;
        font-weight: 200;
        font-style: normal;
    }

    .examination_notes_left {
        height: 16px;
        font-size: 16px;
        color: #e8e6e6;
        text-align: left;
        font-weight: 400;
        font-style: normal;
        margin-bottom: 10px;
    }

    .exam_begins_box .exam_begins_rule {
        position: relative;
        /* display: -webkit-flex; */
        padding: 10px 0;
        border-top: 1px #414141 solid;
        /* background-color: #f9f9f9; */
    }

    .exam_begins_rule .exam_begins_rule_title {
        width: auto;
        height: 20px;
        margin-right: 10px;
        font-size: 14px;
        color: #e8e6e6;
        font-family: source-han-sans-simplified-c, sans-serif;
        font-weight: 200;
        font-style: normal;
    }

    .exam_begins_rule .exam_begins_rule_content {
        width: 520px;
        min-height: 20px;
        position: relative;
        display: block;
    }

    .exam_begins_rule .exam_begins_rule_content p {
        min-height: 20px;
        line-height: 20px;
        display: flex;
        font-size: 14px;
        color: #e8e6e6;
        text-align: left;
        font-family: source-han-sans-simplified-c, sans-serif;
        font-weight: 200;
        font-style: normal;
    }

    .exam_notes {
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #e8e6e6;
        text-align: center;
        font-family: source-han-sans-simplified-c, sans-serif;
        font-weight: 200;
        font-style: normal;
    }

    .exam_notes:first-child {
        margin-top: 40px;
    }

    .exam_btn {
        margin: 0 auto;
        margin-top: 3px;
        display: block;
        text-align: center;
        font-size: 16px;
        color: #fff;
        padding: 6px 20px;
        border-radius: 20px;
        transition: 0.5s ease;
        border: 1px solid #0071c5;
        background: #0071c5;
    }

    .exam_btn:hover {
        color: #000;
        background-color: #fff;
        transition: 0.5s ease;
    }
    .item {
        margin-top: 0px;
        margin-right: 0px;
        margin-left: 0px;
    }
    .has-gutter tr td {
        background: #f30;
    }
    .el-table >>> .has-gutter tr th {
        background-image: -webkit-linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
        background-image: linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
    }
    .el-table >>> .el-table__header thead tr th {
        background-image: -webkit-linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
        background-image: linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
    }
    .el-table >>> .cell .el-button span {
        background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
        background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
        color: #fff;
        padding: 3px 8px;
        border-radius: 15px;
        -webkit-transition: 0.5s ease;
        transition: 0.5s ease;
    }
    .el-table >>> .cell .el-button span:hover {
        color: #333;
    }

    .toolbar >>> .el-pagination {
        margin-top: 8px;
    }
    .toolbar >>> .el-pagination .btn-next,
    .toolbar >>> .el-pagination .btn-prev {
        border-radius: 5px;
        background: unset;
        color: #fff;
    }
    .toolbar >>> .el-pager li {
        min-width: unset;
        margin: 0 5px;
    }
    .curriculum_img {
        cursor: pointer;
        width: 20px;
        height: 20px;
        margin-top: -3px;
        margin-right: 3px;
        display: inline-block;
        vertical-align: middle;
    }
    .exam_btn_excel {
        margin: 0 auto;
        margin-top: 0px;
        display: block;
        text-align: center;
        color: #fff;
        padding: 6px 20px;
        border-radius: 20px;
        -webkit-transition: 0.5s ease;
        transition: 0.5s ease;
        border: 1px solid #00d3ff;
        background-image: linear-gradient(135deg, #00d3ff 0%, #02adff 100%);
    }
    @media screen and (max-width: 1024px) {
        .examPage {
            width: calc(100% - 60px);
        }
        .exam_begins_box {
            width: 94%;
            min-width: 500px;
            padding: 3%;
        }
        .form-item {
            margin-left: 0px;
        }
        .el-col-7,
        .el-col-6 {
            text-align: left;
            min-width: 100px;
            width: unset;
        }
    }
    .el-form-item {
        margin-bottom: 10px;
    }
    .my_select_organization {
        width: 100%;
        padding: 10px;
        border-radius: 5px;
        cursor: pointer;
        border: 1px solid #dcdfe6;
        color: #606266;
        background: #fff;
        -webkit-appearance: none;
    }
    .my_select_organization_disabled {
        color: #c9cccc;
    }
    .my_select_organization_disabled .ds {
        color: #202122 !important;
    }
    .my_select_evaluate {
        width: 100%;
        padding: 10px;
        border-radius: 5px;
        cursor: pointer;
        border: 1px solid #dcdfe6;
        color: #606266;
        background: #fff;
        -webkit-appearance: none;
    }
    .my_select_evaluate_disabled {
        color: #c9cccc;
    }
    .my_select_evaluate_disabled .ds {
        color: #202122 !important;
    }
    .checkBoxlearnProgressList {
        padding-top: 10px;
    }
</style>

<style>
    .el-form-item__label {
        text-align: right;
        float: left;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
        padding: 0 12px 0 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 150px;
    }
</style>



// WEBPACK FOOTER //
// src/views/Aicourse/learnProgressList.vue